
class LinkService {
  geturl() {
    return 'https://stctracker.ponnipa.in.th/'
    // return 'http://localhost:8081';
  }
}

export default new LinkService();

